<template>
  <div class="dashboard__card-loading">
    <div><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
    <div class="loadingText">Loading...</div>
  </div>
</template>

<script>
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min';

  export default {
    name: "CardLoading",
    components: {
      MoonLoader,
    },
  };
</script>
